import React, { Component } from 'react';
import { StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const width = Dimensions.get('window').width;
const isMobile = width <= 550;

const RoundCheckBox = ({
    isActive,
    size = isMobile ? 25 : 20,
    onPress,
    useDarkTheme = false,
}) => {
    const lightThemeStyle = {
        inactiveCheckbox: {
            backgroundColor: Theme.WHITE,
        },
        checkboxContainer: {
            borderColor: Theme.PRIMARY,
        },
        activeCheckbox: {
            backgroundColor: Theme.PRIMARY,
        },
    };

    const darkThemeStyle = {
        inactiveCheckbox: {
            backgroundColor: Theme.GREY_MEDIUM,
        },
        checkboxContainer: {
            borderColor: 'transparent',
        },
        activeCheckbox: {
            backgroundColor: Theme.PRIMARY,
        },
    };

    const theme = useDarkTheme ? darkThemeStyle : lightThemeStyle;
    return <TouchableOpacity style={[
        styles.checkboxContainer,
        theme.checkboxContainer,
        {
            width: defaultScale(size),
            height: defaultScale(size),
        },
        isActive ? theme.activeCheckbox : theme.inactiveCheckbox,
    ]}
        onPress={onPress}>
        {isActive &&
            <Icon
                size={defaultScale(size - 10)}
                style={{ fontFamily: Theme.CustomBold }}
                name="md-checkmark"
                color={Theme.WHITE}
            />
        }
    </TouchableOpacity>
};

const styles = StyleSheet.create({
    checkboxContainer: {
        borderWidth: 2,
        borderRadius: 15,
        // marginRight: 10,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
});

export default RoundCheckBox
